import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { checkSetState } from '@teammo/teammo-general-utils';

import { Label } from 'reactstrap';
import Checkbox from 'app/components/general/Checkbox';
import InputGroupBlock from 'app/components/general/InputGroupBlock';

export default class EventFilter extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    handleFilterChange: PropTypes.func,
    handleFilterToggleChange: PropTypes.func,
    clearFilters: PropTypes.func,
    applyFilters: PropTypes.func,
    filterOptions: PropTypes.array,
    filterConfig: PropTypes.object,
  };

  static defaultProps = {
    title: undefined,
    handleFilterChange: undefined,
    handleFilterToggleChange: undefined,
    clearFilters: undefined,
    applyFilters: undefined,
    filterOptions: [],
    filterConfig: {},
  };

  state = {
    filterConfig: this.props.filterConfig,
  };

  componentWillReceiveProps(newProps) {
    if (newProps.filterConfig !== undefined) {
      const newConfig = {};
      _.mapKeys(newProps.filterConfig, (value, key) => {
        newConfig[key] = true;
      });
    }
    this.setState(checkSetState(this.props, newProps));
  }

  toggleDropdown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  handleClear = () => {
    this.setState({
      dropdownOpen: false,
      filterConfig: {},
    });
    this.props.clearFilters();
  };

  render(): React.ReactNode {
    // const filterNumber = _.isEmpty(this.props.filterConfig)
    //   ? null
    //   : `(${Object.keys(this.props.filterConfig).length})`;

    return _.map(this.props.filterOptions, (option) => {
      const value = option.type === 'select'
        ? this.state.filterConfig[option.accessor] || []
        : this.state.filterConfig[option.accessor] || '';

      return (
        <div className="event-filter-item" key={option.accessor}>
          <InputGroupBlock
            type={option.type}
            inputGroupClassName="no-margin-bottom"
            className="height-40"
            labelText={null}
            name={option.accessor}
            placeholder={option.label}
            aria-label={option.label}
            autoComplete="off"
            autoFocus
            createable
            clearable
            isMulti={option.isMulti}
            tabIndex="1"
            options={option.options}
            value={value}
            onChange={this.props.handleFilterChange}
          />
        </div>
      );
    });
  }
}
